exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 1023px) {\n  /* Restore mobile spacing from before the Bulma upgrade. */\n  .tvm-page-fluid {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"tvm-page-fluid": "tvm-page-fluid"
};